import React from "react";
import ViewShippingOrderForm from "../ShippingOrder/ViewShippingOrderForm";

export default function ViewReplacement() {
    return (
        <ViewShippingOrderForm type="VIEW" backText="Replacement Orders" backTo={"/replacement"} heading={"User Information"} heading2={"Shipping Information"} />
    );
}
